import axios from 'axios'
import { Report } from '../dtos/Report'
import { getReportAge } from '../utils/report'
import config from './../config'

const apiUrls = {
    getReports: (serviceContractOnly: boolean) => `${config.apiUrl}/report/?serviceContractOnly=${serviceContractOnly}`,
    deleteReport: (reportId: number) => `${config.apiUrl}/report/${reportId}`
}

export const reportsApi = {
    getReports: async (serviceContractOnly: boolean) => {
        const result = await axios.get<Report[]>(apiUrls.getReports(serviceContractOnly))
        if (result.status !== 200)
            return [] as Report[]

        const reportData = result.data
        reportData.forEach(x => {
                x.isOutTimed = config.ommitedServicesInOuttime.some(o => o === x.service)
                    ? false
                    : getReportAge(x.timestamp) > config.reportOuttimeAgeWarn
        })
        return reportData
    },
    deleteReport: async (reportId: number) => {
        return await axios.delete(apiUrls.deleteReport(reportId))
    }
}
